import {LocalParamList} from '../../../../../shared/components/tabBar/components/types';
import View from './view';
import {change, getFormValues, initialize, reduxForm, setSubmitFailed, submit} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import React, {createElement, useEffect} from 'react';
import {updateProfileSettings} from '../../../../../redux/actions/profile';
import {useDispatch, useSelector} from 'react-redux';
import {IStateProps} from './model';
import {profileSettingsSelector} from '../../../../../redux/selectors/profile';
import {validationPipe} from '../../../../../shared/pipes';
import {RegExps} from '../../../../../shared/constants/regexps';
import {UpdateProfileSettingsRequestPayload} from '../../../../../shared/models/api';
import {Screens} from '../../../../../shared/routing';
import {useNavigation, NavigationHelpers} from '@react-navigation/native';
import {useModal} from '../../../../../shared/components/modal';
import {Modal} from '../../../../../shared/components/modal/modal';
import {ProfileChangePassword} from '../../../common/changePassword';
import {useModifiedRouterParams} from '../../../../../shared/hooks/routeParams';
import {IChangePasswordForm} from '../../../common/changePassword/model';
import {ProfileUserContactsRoute} from '../../../mobile/components/contacts';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {useConfirmEmail} from '../../../../../shared/hooks/useConfirmEmail';

const getFormErrors = (formData: any) =>
  validationPipe(formData, [
    {
      names: 'PhoneNumber',
      error: 'Не корректный формат номера',
      type: 'pattern',
      pattern: RegExps.phoneNumber,
    },
    {
      names: 'Email',
      error: 'Не корректный формат почты',
      type: 'pattern',
      pattern: RegExps.email,
    },
  ]);

const Form = reduxForm<UpdateProfileSettingsRequestPayload, IStateProps>({
  form: Forms.desktopSettings,
})(View);

export const DesktopProfileSettings: React.FC<{route: ProfileUserContactsRoute}> = ({
  route: {params: {op = '', code = ''} = {}},
}) => {
  const dispatch = useDispatch();
  const isEmailConfirmationNeeded = React.useMemo(() => !!(op === 'changeEmail' && code), [op, code]);
  const [isLoading, setIsLoading] = React.useState(isEmailConfirmationNeeded);
  const navigation = useNavigation();

  useEffect(() => {
    if (op === 'restorePassEmail' || op == 'changeEmail') {
      navigation.reset({
        index: 2,
        routes: [{name: 'main'}, {name: 'desktopProfileMe'}, {name: 'desktopProfileSettings'}],
      });
    }
  }, [op]);

  useConfirmEmail(isEmailConfirmationNeeded, code, setIsLoading);

  const modals = useModal();
  const profileSettings = useSelector(profileSettingsSelector());
  const formValues = useSelector(getFormValues(Forms.desktopSettings));
  const nav = useNavigation() as unknown as NavigationHelpers<LocalParamList>;

  useEffect(() => {
    dispatch(initialize(Forms.desktopSettings, profileSettings));
  }, [profileSettings]);

  useModifiedRouterParams((params) => {
    if (params.modal === 'change-password') {
      modals.show({
        render(modal, methods) {
          const hideModal = () => {
            methods.remove(modal.id);
            nav.navigate(Screens.DesktopProfileSettings, {modal: ''});
          };

          return (
            <Modal title='Изменение пароля' onClose={hideModal}>
              <ProfileChangePassword onFormSubmitted={hideModal} />
            </Modal>
          );
        },
      });
    }
  });

  if (!profileSettings) {
    return null;
  }

  return (
    <LoadableContent loading={isLoading}>
      {createElement(Form, {
        profileSettings,
        onPressChangePassword() {
          const initialFormData: IChangePasswordForm = {
            confirmPassword: '',
            newPassword: '',
            oldPassword: '',
          };

          dispatch(initialize(Forms.changePassword, initialFormData));
          nav.navigate(Screens.DesktopProfileSettings, {modal: 'change-password'});
        },
        onSwitchContactsPhone(event) {
          if (event.name === 'revert') {
            dispatch(change(Forms.desktopSettings, 'PhoneNumber', profileSettings.phoneNumber));
          }

          if (event.name === 'swap' && event.nextView === 'initial') {
            const errors = getFormErrors(formValues);
            if (errors) {
              dispatch(setSubmitFailed(Forms.desktopSettings, errors));
              if (errors?.hasOwnProperty('PhoneNumber')) {
                return false;
              }
            }

            dispatch(submit(Forms.desktopSettings));
          }
        },
        onSwitchContactsEmail(event) {
          if (event.name === 'revert') {
            dispatch(change(Forms.desktopSettings, 'Email', profileSettings.email));
          }

          if (event.name === 'swap' && event.nextView === 'initial') {
            const errors = getFormErrors(formValues);
            if (errors) {
              dispatch(setSubmitFailed(Forms.desktopSettings, errors));
              if (errors?.hasOwnProperty('Email')) {
                return false;
              }
            }

            dispatch(submit(Forms.desktopSettings));
          }
        },
        onSubmit(formData: UpdateProfileSettingsRequestPayload) {
          dispatch(updateProfileSettings(formData));
        },
      })}
    </LoadableContent>
  );
};
